<main class="d-flex" [class.busy]="busy" *ngIf="ready$ | async">
    <div *ngIf="busy" class="busy-overlay"></div>
    <app-navigation></app-navigation>
    <router-outlet></router-outlet>
</main>